<select [ngModel]="selectedLanguage" (change)="changeLanguage($event)">
    <option *ngFor="let lang of availableLanguages" [value]="lang.code">
      {{ lang.label }}
    </option>
</select>